
<div class="enkai__areaDetailList">
  <h3 class="enkai__areaDetailCaption">エリアを選択する</h3>
  <template v-if="station">
    <template v-if="(pageType || shopType) && yenOrPeople && count">
      <template v-for="station in stationsInAreaDetail">
        <a :href="`../../../S${ station.id }/${ pageType ? pageType : shopType }/${ count }${ yenOrPeopleLabel }/`" :key="station.name">{{ station.name }}</a>
      </template>
    </template>
    <template v-else-if="peopleCount && yenCount">
      <template v-for="station in stationsInAreaDetail">
        <a :href="`../../../S${ station.id }/${ peopleCount }people/${ yenCount }yen/`" :key="station.name">{{ station.name }}</a>
      </template>
    </template>
    <template v-else-if="(pageType || shopType)">
      <template v-for="station in stationsInAreaDetail">
        <a :href="`../../S${ station.id }/${ pageType ? pageType : shopType }/`" :key="station.name">{{ station.name }}</a>
      </template>
    </template>
    <template v-else-if="yenOrPeople && count">
      <template v-for="station in stationsInAreaDetail">
        <a :href="`../../S${ station.id }/${ count }${ yenOrPeopleLabel }/`" :key="station.name">{{ station.name }}</a>
      </template>
    </template>
    <template v-else>
      <template v-for="station in stationsInAreaDetail">
        <a :href="`../S${ station.id }/`" :key="station.name">{{ station.name }}</a>
      </template>
    </template>
  </template>
  <template v-else-if="areaDetail">
    <template v-if="(pageType || shopType) && yenOrPeople && count">
      <template v-for="station in stationsInAreaDetail">
        <a :href="`../../S${ station.id }/${ pageType ? pageType : shopType }/${ count }${ yenOrPeopleLabel }/`" :key="station.name">{{ station.name }}</a>
      </template>
    </template>
    <template v-else-if="peopleCount && yenCount">
      <template v-for="station in stationsInAreaDetail">
        <a :href="`../../S${ station.id }/${ peopleCount }people/${ yenCount }yen/`" :key="station.name">{{ station.name }}</a>
      </template>
    </template>
    <template v-else-if="(pageType || shopType)">
      <template v-for="station in stationsInAreaDetail">
        <a :href="`../S${ station.id }/${ pageType ? pageType : shopType }/`" :key="station.name">{{ station.name }}</a>
      </template>
    </template>
    <template v-else-if="yenOrPeople && count">
      <template v-for="station in stationsInAreaDetail">
        <a :href="`../S${ station.id }/${ count }${ yenOrPeopleLabel }/`" :key="station.name">{{ station.name }}</a>
      </template>
    </template>
    <template v-else>
      <template v-for="station in stationsInAreaDetail">
        <a :href="`./S${ station.id }/`" :key="station.name">{{ station.name }}</a>
      </template>
    </template>
  </template>
  <template v-else-if="area">
    <template v-if="(pageType || shopType) && yenOrPeople && count">
      <template v-for="areaDetail in areaDetailsInArea">
        <a :href="`../../AD${ areaDetail.id }/${ pageType ? pageType : shopType }/${ count }${ yenOrPeopleLabel }/`" :key="areaDetail.name">{{ areaDetail.name }}</a>
      </template>
    </template>
    <template v-else-if="peopleCount && yenCount">
      <template v-for="areaDetail in areaDetailsInArea">
        <a :href="`../../AD${ areaDetail.id }/${ peopleCount }people/${ yenCount }yen/`" :key="areaDetail.name">{{ areaDetail.name }}</a>
      </template>
    </template>
    <template v-else-if="(pageType || shopType)">
      <template v-for="areaDetail in areaDetailsInArea">
        <a :href="`../AD${ areaDetail.id }/${ pageType ? pageType : shopType }/`" :key="areaDetail.name">{{ areaDetail.name }}</a>
      </template>
    </template>
    <template v-else-if="yenOrPeople && count">
      <template v-for="areaDetail in areaDetailsInArea">
        <a :href="`../AD${ areaDetail.id }/${ count }${ yenOrPeopleLabel }/`" :key="areaDetail.name">{{ areaDetail.name }}</a>
      </template>
    </template>
    <template v-else>
      <template v-for="areaDetail in areaDetailsInArea">
        <a :href="`./AD${ areaDetail.id }/`" :key="areaDetail.name">{{ areaDetail.name }}</a>
      </template>
    </template>
  </template>
</div>
